// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac13a914","667":"0f3f30c8"}[chunkId] + ".chunk.js";
};